import React,{useEffect,useState} from 'react';
import styled from 'styled-components';
import { AppState } from '../../store';
import { withRouter, useHistory } from 'react-router';
import { connect } from 'react-redux';
import { setCurrentCategory, setSubCategoriesStatus,getCategory } from '../../store/categories/functions';
import { fetchFormFields, finder, postFormDataItem } from '../../store/forms/functions';
import { Form } from '../../store/forms/types';
import {DynamicForm, Card, CardActionButton} from '../elements'
import { CONSTS } from '../elements/_constants';
type FormItemNewComponentProps = {
    className?: string,
    match: any,
    onToggleSubCategories: Function,
    onFetchFormFields: Function,
    onPostFormData: Function,
    currentCategoryId: number,
    currentCategory: any,
    categories: any,
    currentForm?: Form
}

const FormItemNewComponent = (props: FormItemNewComponentProps) => {
  const [form, setForm] = useState<Form>();
  let history = useHistory();
  useEffect(() => {
    props.onFetchFormFields(parseInt(""+props.match.params.formId));
    return () => {};
  }, [])

  useEffect(() => {
    setForm(props.currentForm);
    return () => {};
  }, [props.currentForm])

  const handleSubmit = (data :any) => {
    props.onPostFormData(parseInt(""+props.match.params.formId),data,()=>{
        history.push(history.location.pathname.substring(0, history.location.pathname.lastIndexOf("/")))
    })
  }
 
    return (
        <div className={props.className}>
          {props.currentForm &&
            <Card
              title={props.currentForm.title+": مورد جدید"}
              headerMeta={<>
                <CardActionButton title="بازگشت" to={props.match.url.substring(0, props.match.url.lastIndexOf("/"))} iconClassName="icon-icons8-cancel" hasBorderRight={true}/>
              </>}
            >
                {form && <DynamicForm onSubmit={handleSubmit} isEdit={false} fields={form.formFields}/>}
            </Card> 
          }
        </div>
    )
}

const FormItemNew = styled(FormItemNewComponent)`
  
` 

const mapStateToProps = (state: AppState,ownProps: any) => ({
  categories: state.categories,
  currentCategory: getCategory(state.categories.items,state.categories.currentCategoryId),
  currentCategoryId: state.categories.currentCategoryId,
  currentForm: findForm(ownProps.match.params.formId,state.forms.forms)
});
function findForm(formId: any,forms: Form[]) {
  if(!formId || !forms) return;
  let formIndex = finder(parseInt(""+formId),forms);
  return forms[formIndex];
}
const mapDispatchToProps = (dispatch:any) => {
    return {
      onToggleSubCategories   : (open: boolean)   =>{
        dispatch(setSubCategoriesStatus(open));
      },
      onFetchFormFields: (id: number)=>{
        dispatch(fetchFormFields(id))
      },
      onPostFormData: (formId: number,formData: any,then: Function) => {
        dispatch(postFormDataItem(formId,formData,then))
      }
    };
  };
  
  export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
  )(FormItemNew));
